import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../components/AppIcon';
import Button from '../../components/ui/Button';
import Header from '../../components/ui/Header';
import MetricsCard from './components/MetricsCard';
import ActivityFeed from './components/ActivityFeed';
import QuickActions from './components/QuickActions';
import SavedSearches from './components/SavedSearches';
import CreditManagement from './components/CreditManagement';
import TeamCollaboration from './components/TeamCollaboration';
import RecruitmentAnalytics from './components/RecruitmentAnalytics';

const EmployerDashboard = () => {
  const [currentLanguage, setCurrentLanguage] = useState('en');
  const [user] = useState({
    name: "TechCorp AS",
    email: "hr@techcorp.no",
    role: "employer",
    avatar: "https://images.unsplash.com/photo-1698311427676-9495b8dc7244",
    avatarAlt: "Modern office building with glass facade representing TechCorp company headquarters"
  });

  useEffect(() => {
    const savedLanguage = localStorage.getItem('workfolio_language') || 'en';
    setCurrentLanguage(savedLanguage);
  }, []);

  const metricsData = [
  {
    title: "Available Credits",
    value: "12",
    subtitle: "1,788 NOK value",
    icon: "CreditCard",
    color: "primary",
    trend: { type: "neutral", value: "" }
  },
  {
    title: "Total Unlocks",
    value: "47",
    subtitle: "This month: 8",
    icon: "Unlock",
    color: "success",
    trend: { type: "positive", value: "+23%" }
  },
  {
    title: "Active Searches",
    value: "3",
    subtitle: "7 new matches",
    icon: "Search",
    color: "accent",
    trend: { type: "positive", value: "+2" }
  },
  {
    title: "Shortlisted",
    value: "24",
    subtitle: "Across 3 lists",
    icon: "Bookmark",
    color: "warning",
    trend: { type: "positive", value: "+5" }
  }];


  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main className="container mx-auto px-6 lg:px-8 py-8">
        {/* Header Section */}
        <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between mb-8">
          <div className="mb-6 lg:mb-0">
            <div className="flex items-center space-x-4 mb-2">
              <img
                src={user?.avatar}
                alt={user?.avatarAlt}
                className="h-12 w-12 rounded-lg object-cover" />

              <div>
                <h1 className="text-2xl font-semibold text-foreground">
                  Welcome back, {user?.name}
                </h1>
                <p className="text-muted-foreground">
                  Manage your recruitment pipeline and discover top talent
                </p>
              </div>
            </div>
          </div>
          
          <div className="flex items-center space-x-3">
            <Button variant="outline" iconName="Settings" iconPosition="left">
              Settings
            </Button>
            <Button asChild>
              <Link to="/employer-search-interface">
                <Icon name="Search" size={16} className="mr-2" />
                Search Candidates
              </Link>
            </Button>
          </div>
        </div>

        {/* Metrics Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
          {metricsData?.map((metric, index) =>
          <MetricsCard
            key={index}
            title={metric?.title}
            value={metric?.value}
            subtitle={metric?.subtitle}
            icon={metric?.icon}
            color={metric?.color}
            trend={metric?.trend} />

          )}
        </div>

        {/* Main Content Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 mb-8">
          {/* Left Column */}
          <div className="lg:col-span-2 space-y-8">
            <QuickActions />
            <SavedSearches />
            <RecruitmentAnalytics />
          </div>
          
          {/* Right Column */}
          <div className="space-y-8">
            <ActivityFeed />
            <CreditManagement />
          </div>
        </div>

        {/* Team Collaboration - Full Width */}
        <div className="mb-8">
          <TeamCollaboration />
        </div>

        {/* Quick Stats Footer */}
        <div className="bg-card rounded-xl p-6 shadow-elevation border border-border">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
            <div className="text-center">
              <div className="text-2xl font-semibold text-primary mb-1">156</div>
              <div className="text-sm text-muted-foreground">Profile Views</div>
            </div>
            <div className="text-center">
              <div className="text-2xl font-semibold text-success mb-1">74%</div>
              <div className="text-sm text-muted-foreground">Response Rate</div>
            </div>
            <div className="text-center">
              <div className="text-2xl font-semibold text-accent mb-1">2.3</div>
              <div className="text-sm text-muted-foreground">Avg. Days to Respond</div>
            </div>
            <div className="text-center">
              <div className="text-2xl font-semibold text-warning mb-1">1,890</div>
              <div className="text-sm text-muted-foreground">NOK Cost per Hire</div>
            </div>
          </div>
        </div>
      </main>
    </div>);

};

export default EmployerDashboard;